import { X } from "lucide-react";
import { Theme } from "../../../theme";
import { OVERLAY_Z, OverlayPortal } from "../utils/OverlayPortal";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  closeIcon?: boolean;
  /** Actions discrètes affichées à droite du titre, sur le modèle de `Card`. */
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export function Modal({
  isOpen,
  onClose,
  title,
  closeIcon,
  actions,
  children,
}: ModalProps) {
  if (!isOpen) return null;

  // Montée sous `<body>` : ouverte depuis un volet (`Shutter`), elle se calerait sinon sur la boîte
  // du volet, transformé par son animation d'ouverture. Voir `OverlayPortal`.
  return (
    <OverlayPortal>
      <div
        className={`max-h-dvh max-w-[90vh] md:max-w-screen fixed inset-0 ${OVERLAY_Z} overflow-y-auto flex items-center justify-center mt-[0px!important]`}
      >
        <div
          className="fixed inset-0 bg-gray-500/75 dark:bg-gray-900/80"
          onClick={(e) => {
            e.stopPropagation();
            onClose();
          }}
        />

        <div
          className={`relative bg-white dark:bg-gray-800 shadow-lg ${Theme.greyBorder}`}
        >
          {/* Titre non scrollable */}
          {!!title && (
            <div className="px-6 pt-4 flex items-center justify-between select-none">
              <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
                {title}
              </h3>
              <div className="flex items-center gap-2">
                {actions}
                {closeIcon && (
                  <button
                    type="button"
                    className="p-2 text-gray-900 dark:text-gray-100"
                    onClick={(e) => {
                      e.stopPropagation();
                      onClose();
                    }}
                  >
                    <X size={24} />
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Contenu scrollable */}
          <div className="px-6 pt-2 overflow-auto flex-1 max-h-[calc(90dvh-60px)]">
            {children}
          </div>
        </div>
      </div>
    </OverlayPortal>
  );
}
